/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `BL` - Baled
* `LB` - Loosely Baled
* `TB` - Tightly Baled
* `BG` - Bagged
* `LS` - Loose
* `BQ` - Briquettes
* `BISCUITS` - Biscuits
 */
export type MaterialStorageType = typeof MaterialStorageType[keyof typeof MaterialStorageType];


export const MaterialStorageType = {
  BL: 'BL',
  LB: 'LB',
  TB: 'TB',
  BG: 'BG',
  LS: 'LS',
  BQ: 'BQ',
  BISCUITS: 'BISCUITS',
} as const;
